// extracted by mini-css-extract-plugin
export default {"root":"SignUpFormUserRequest_root__-JjQk","inputLink":"SignUpFormUserRequest_inputLink__2vCCU","after":"SignUpFormUserRequest_after__dcO9R"};